import React, { useState } from 'react';
import { organsAPI } from 'src/api/modules/organs';
import BaseModal from 'src/common/components/Modal';
import notice from 'src/common/components/Notice';
import UtilInputs from 'src/common/components/UtilInputs';
import { defaultBody, newBodyForm } from '../utils/form_data';

const AddOrganModal = ({ open, onClose, onSuccess, parent }) => {
	const [form, setForm] = useState(defaultBody);

	const handleChange = ({ target }) =>
		setForm({ ...form, [target.name]: target.value });

	const onSaveData = () => {
		const parentFlag = { ...parent };
		const data = {
			...form,
			organoId: parentFlag.id || undefined,
		};
		organsAPI
			.post(data)
			.then((res) => {
				onSuccess('Órgano creado correctamente', 'success', 1);
				setForm(defaultBody);
			})
			.catch(() => {
				notice('Ha ocurrido un error en su solicitud');
			});
	};

	return (
		<BaseModal
			open={open}
			mainText="Agregar Órgano Colegiado"
			onConfirm={onSaveData}
			onClose={() => {
				onClose();
				setForm(defaultBody);
			}}
			onCancel={() => {
				onClose();
				setForm(defaultBody);
			}}
		>
			<UtilInputs
				width="95%"
				formValues={form}
				inputValues={newBodyForm}
				onValuesChange={handleChange}
			/>
		</BaseModal>
	);
};

export default AddOrganModal;
